import { motion } from "framer-motion";
import SiteNav from "../components/SiteNav";
import SiteFooter from "../components/SiteFooter";
import Hero from "../components/landing/Hero";
import EditorialMarquee from "../components/landing/EditorialMarquee";
import Chapters, { FoundingCta } from "../components/landing/Chapters";
import Vision from "../components/landing/Vision";
import FoundingForm from "../components/landing/FoundingForm";

export default function Landing() {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.7 }}
      className="grain bg-[#17151B] text-[#F7F3FA] min-h-screen"
      data-testid="landing-page"
    >
      <SiteNav />
      <Hero />
      <EditorialMarquee />
      <Chapters />
      <Vision />
      <FoundingCta />
      <FoundingForm />
      <SiteFooter />
    </motion.main>
  );
}